import * as yup from "yup";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { IoSaveOutline } from "react-icons/io5";
import { FaCircleNotch } from "react-icons/fa";

import ReactSelectAsync from "./../../../../../components/common/ReactSelectAsync";
import Toaster from "../../../../../components/common/Toaster";

import referralService from "./../../../../../services/referralService";
import moment from "moment";

const schema = yup.object({
  referral_id: yup.object().shape({
    label: yup.string().required("Please select account."),
    value: yup.string().required("Please select account."),
  }),
});

const ReferralForm = ({ id, isLoading, setLoading, onSuccess }) => {
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const options = async (search, loadedOptions, { page }) => {
    const params = {
      search_query: search,
      current_page: page,
      page_size: 10,
      sort_column: { path: "name", order: "asc" },
    };

    const response = await referralService.getAvailableReferralsAsync(
      id,
      params
    );
    const { result: data, count, total_count } = response;

    const options = data.map((item) => {
      const container = {};
      container["label"] = item.first_name + " " + item.last_name;
      container["value"] = item.id;

      return container;
    });

    const hasMore = total_count > count;

    return {
      options,
      hasMore,
      additional: {
        page: page + 1,
      },
    };
  };

  const onSubmit = async (data) => {
    try {
      setLoading(true);

      const { result: referee_id } = await referralService.assignReferralAsync(
        id,
        data.referral_id.value
      );

      const item = {
        id: referee_id,
        referee_name: data.referral_id.label,
        created_on: moment().toISOString(),
      };

      setLoading(false);
      Toaster.Success("Account Assigned Successfully");
      onSuccess(item);
    } catch (ex) {
      setLoading(false);
      Toaster.Error("Something went wrong.");
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="p-8 space-y-6">
      <div className="grid grid-cols-2">
        <div className="col-span-2">
          <ReactSelectAsync
            id="referral-dropdown"
            name="referral_id"
            title="Account"
            options={options}
            control={control}
            register={register("referral_id")}
            errors={errors}
          />
        </div>
      </div>
      <div className="grid grid-2 pt-2">
        <div className="col-span-2">
          <button
            type="submit"
            className="button button-primary disabled:opacity-70 disabled:cursor-not-allowed"
            disabled={isLoading}
          >
            {isLoading && <FaCircleNotch className="animate-spin mr-3" />}
            {!isLoading && <IoSaveOutline className="mr-3" />}
            Save Changes
          </button>
        </div>
      </div>
    </form>
  );
};

export default ReferralForm;
